import { supabase } from '../../lib/supabase'
import type { DetailRecord } from './detailedOutFigures'

type DetailRow = {
  employee_id: string
  detail_type: string
  originating_team_id: string
  destination: string
  start_date: string
  end_date: string
  teams: { name: string } | null
  employees: { display_name: string; employee_identifier: string } | null
}

// Every detail the signed-in account can read: a supervisor's own teams',
// an administrator's every team's (details_read_team). The destination is the
// synthetic detail location.
export async function getDetailRecords(): Promise<DetailRecord[]> {
  const { data, error } = await supabase
    .from('details')
    .select(
      'employee_id, detail_type, originating_team_id, destination, start_date, end_date, teams(name), employees(display_name, employee_identifier)',
    )
    .order('start_date', { ascending: true })
  if (error) throw new Error('The detailed-out report could not be loaded.')
  return ((data ?? []) as unknown as DetailRow[]).flatMap((row) =>
    row.employees
      ? [
          {
            employeeId: row.employee_id,
            identifier: row.employees.employee_identifier,
            employee: row.employees.display_name,
            detailType: row.detail_type,
            team: row.teams?.name ?? '',
            teamId: row.originating_team_id,
            destination: row.destination,
            startDate: row.start_date,
            endDate: row.end_date,
          },
        ]
      : [],
  )
}
